"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Footer_1 = __importDefault(require("../Footer"));
const Layout = ({ children }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("main", { className: "p-[50px] pb-[200px] lg:p-[50px] lg:pb-[200px] max-lg:p-[35px] max-lg:pb-[200px]" }, children),
    react_1.default.createElement(Footer_1.default, null)));
exports.default = Layout;
